export default __webpack_public_path__ + "static/media/loader.dc391463.svg";